import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    token: null,
    admin: null,
  },
  reducers: {
    setAdmin: (state, action) => {
      state.token = action.payload.token;
      state.admin = action.payload.admin;
    },
    logoutAdmin: (state) => {
      state.token = null;
      state.admin = null;
    },
  },
});

export const { setAdmin, logoutAdmin } = adminSlice.actions;
export default adminSlice.reducer;
